<div class="question-type__text">
  <h1 class="fs__xxl">Terminate</h1>
  <p class="fs__md">
    Terminate a survey based on specific conditions. This is used if you want to end a survey based on an answer provided by the participant. The participant
    will be directed to the result page of the survey and notified they did not qualify for the survey
  </p>
</div>
